import './PrincipalMessage.css';
import pic1 from "../assets/IMG_4300.webp";

const PrincipalMessage = () => {
  const councilMembers = [
    { name: 'Sh. Jaideep Bihani', role: '(President)' },
    { name: 'Sh. Himanshu Bihani', role: '(Vice President)' },
    { name: 'Mrs. Nalini Dhingra', role: '(Principal & Secretary)' },
    { name: 'Sh. Deepak Jain S/o Sh. Manmohan Jain', role: ' (Member/Trustee)' },
    { name: 'Sh. Madhu Sudan Bihani S/o Sh. Suhil Kumar Bihani', role: ' (Member/Trustee)' },
    { name: 'Sh. Sharad Kumar Bihani', role: '(Member/Trustee)' },
    { name: 'Sh. Vimal Bihani', role: '(Member)' },
    { name: 'Sh. Satish Chander Jain', role: '(Member)' },
    { name: 'Smt. Ranjana Bihani', role: '(Member)' },
    { name: 'Smt. Shailja Chitlangyia W/o Sh. Rakesh Chitlangyia', role: ' (Member)' },
    { name: 'Smt. Shruti Bihani W/o Sh. Neeraj Bihani', role: ' (Member)' },
    { name: 'Smt. Monika Bihani', role: '(Member)' },
    { name: 'Smt. Urmila Chitlangyia D/o Sh. Shankar Lal Bhattar', role: ' (Member)' },
    { name: 'Smt. Kavita Binnani W/o Sh. Prashant Binnani', role: ' (Member)' },
    { name: 'Dr. Richa Periwal W/o Dr. Aditya Periwal', role: ' (Member)' },
    { name: 'Sh. M.S. Vig - Principal CBSE School', role: ' (Member)' },
    { name: 'Smt. Minu Sharma - Principal CBSE School', role: ' (Member)' },
    { name: 'Smt. Nalini Dhingra - Academy Teacher', role: ' (Member)' },
    { name: 'Sh. Varun Maheshwari Member', role: ' (Lecturer Other Dept)' },
    { name: 'Dr. Gulshan Kumar', role: '(College Lecturer)' },
    { name: 'Dr. Ajay Sharma', role: '- Present Students Parents' },
    { name: 'Present Students Parents', role: '' },
  ];

  return (
    <>
     {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>MESSAGE FROM PRINCIPAL</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Prinicpal</li>
          </ul>
        </div>
      </section>
    <div className="page-container">
      <div className="main-container">
        <div className="header">
          <h1 className="header-title">Principal's Message</h1>
        </div>

        <div className="content">
          <div className="left-section">
            <div className="principal-card">
              <div className="principal-img">
                <img src={pic1} alt="Principal Mrs. Nalini Dhingra" />
              </div>
              <p className="principal-label">PRINCIPAL</p>
              <h2 className="principal-name">MRS. NALINI DHINGRA</h2>
              <p className="principal-title">Principal, Bihani Children's Academy</p>
            </div>
                     <div className="quote-box">
              "Education awakens the power beauty that lie within us."
            </div>
            <div className="message-box">
             
              <p>
                Education does not only man academic excellence. It rather is a harmonious and synchronized combination of hand (skills like various arts), head (Intellectual Power) and heart (Value System). In the present era of digitalized world, it is the biggest challenge before educators and parents, to nurture the young minds with the indelible impressions of a holistic education.
              </p>
              <p>
                Therefore, we come up with a vision to foster different facets of a student in order to see him/her developing as a vibrant student, responsible citizen and above all a generous and sentient human being. Our pedagogy is child centric, with emphasis on discipline, over-all growth and development of our students. The school is hailed as a deemed institution which has carved a niche for itself, with the dedicated efforts of our deeply committed management, experienced teachers and active parents. We take immense efforts of making the child€™s journey in school rich with many enjoyable learning experiences by providing them an exquisite platform to hone their creative and inter-personal skills. The school is pledged to instill the much required values in the student without compromising their temperament and questioning spirit. Notwithstanding the challenges to develop altruistic human beings we raised standards of intellect, let us become equal stakeholders in moulding our children into desirable individuals.
              </p>
              <p>
                Your valuable suggestions are always welceome.
              </p>
            </div>
          </div>

            {/* Management Council Sidebar */}
        <div className="bca-council-box">
          <h2 className="bca-council-title">Management Council</h2>
          <ul className="bca-council-members">
            {councilMembers.map((member, index) => (
              <li key={index} className="bca-council-member">
                <strong>{member.name}</strong> {member.role && <span>{member.role}</span>}
              </li>
            ))}
          </ul>
        </div>
        </div>
      </div>
    </div>
              </>
  );
};

export default PrincipalMessage;